import fetch from '@/apiconfig/index';



export function ocompanyGetLogoByCode(parameter) {
  return fetch({
    url: '/api/companystaff/ocompany/getLogoByCode',
    method: 'get',
    params: parameter
  });
}
